import { useMemo } from 'react'
import { useSearchParams } from 'react-router-dom'

import Pagination from '@/compoments/common/Pagination'
import PageLoader from '@/compoments/PageLoader'
import { useGetCustomerFeedbacksQuery } from '@/services/executives/executives'
import type { CustomerFeedbacksQueryParams } from '@/services/executives/response.interface'

import Filters from './parts/Filters'
import Table from './parts/Table'

const ExecutivesCustomerFeedbackPage = () => {
    const [searchParams, setSearchParams] = useSearchParams()

    const params = useMemo(
        () =>
            ({
                page: +(searchParams.get('page') || 1),
                rating: searchParams.get('rating'),
                technician: searchParams.get('technician'),
            }) as CustomerFeedbacksQueryParams,
        [searchParams],
    )

    const { data, isLoading } = useGetCustomerFeedbacksQuery(params)

    const pageData = data?.data

    if (isLoading) {
        return <PageLoader />
    }
    return (
        <main className="content">
            <div className="px-container">
                <div className="table-group">
                    <div className="table-header flex items-center justify-between">
                        <Filters />
                    </div>
                    <div className="table-body table-responsive p-0">
                        <Table data={pageData} />
                    </div>
                </div>
                <Pagination pagination={data?.pagination} />
            </div>
        </main>
    )
}

export default ExecutivesCustomerFeedbackPage
